// AJAX filter loading
function loadFilteredProducts(url) {
  const productsGrid = document.querySelector('[data-products-grid]')
  if (!productsGrid) return

  // Store original grid HTML to restore structure
  const gridHeight = productsGrid.offsetHeight

  const parsedPerPage = parseInt(productsGrid.getAttribute('data-products-per-page'), 10)
  const skeletonCount = Number.isFinite(parsedPerPage) && parsedPerPage > 0 ? parsedPerPage : 16

  // Create skeleton loading HTML matching product-card structure exactly
  const skeletonHTML = Array(skeletonCount)
    .fill(
      `
    <div class='group relative w-full animate-pulse'>
      <div class='block'>
        <div class='relative rounded-lg overflow-hidden mb-4 h-[160px] md:h-[308px] md:w-[308px] bg-gray-200'></div>
        <div class='space-y-4'>
          <div class='flex gap-1'>
            <div class='w-[22.4px] h-[26px] md:w-[33.7px] md:h-[38.7px] rounded-sm bg-gray-200'></div>
            <div class='w-[22.4px] h-[26px] md:w-[33.7px] md:h-[38.7px] rounded-sm bg-gray-200'></div>
            <div class='w-[22.4px] h-[26px] md:w-[33.7px] md:h-[38.7px] rounded-sm bg-gray-200'></div>
            <div class='w-[22.4px] h-[26px] md:w-[33.7px] md:h-[38.7px] rounded-sm bg-gray-200'></div>
          </div>
          <div class='h-[18px] md:h-7 bg-gray-200 rounded w-3/4'></div>
          <div class='flex flex-col gap-0.5'>
            <div class='h-[10px] md:h-[14px] bg-gray-200 rounded w-16'></div>
            <div class='h-[16px] md:h-7 bg-gray-200 rounded w-20'></div>
          </div>
        </div>
      </div>
    </div>
  `
    )
    .join('')

  // Show skeleton loading
  productsGrid.innerHTML = skeletonHTML
  productsGrid.style.minHeight = gridHeight + 'px'

  // Fetch new content
  fetch(url)
    .then(function (response) {
      return response.text()
    })
    .then(function (html) {
      // Parse response
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')
      const newGrid = doc.querySelector('[data-products-grid]')

      if (newGrid) {
        // Replace grid content
        productsGrid.innerHTML = newGrid.innerHTML
        productsGrid.setAttribute('data-current-page', newGrid.getAttribute('data-current-page'))
        productsGrid.setAttribute('data-total-pages', newGrid.getAttribute('data-total-pages'))
        const perPage = newGrid.getAttribute('data-products-per-page')
        if (perPage) {
          productsGrid.setAttribute('data-products-per-page', perPage)
        }
      }

      // Update product count (both desktop and mobile)
      const newCount = doc.querySelector('[data-product-count]')
      const currentCounts = document.querySelectorAll('[data-product-count]')
      if (newCount && currentCounts.length > 0) {
        currentCounts.forEach((count) => {
          count.textContent = newCount.textContent
        })
      }

      // Update reset all button visibility (desktop)
      const newDesktopResetContainer = doc
        .querySelector('[data-filter-bar]')
        .parentElement.querySelector('[data-reset-all-container]')
      const currentDesktopResetContainer = document
        .querySelector('[data-filter-bar]')
        .parentElement.querySelector('[data-reset-all-container]')

      if (newDesktopResetContainer && !currentDesktopResetContainer) {
        // Need to add reset button
        const filterBarParent = document.querySelector('[data-filter-bar]').parentElement
        filterBarParent.insertAdjacentHTML('beforeend', newDesktopResetContainer.outerHTML)
      } else if (!newDesktopResetContainer && currentDesktopResetContainer) {
        // Need to remove reset button
        currentDesktopResetContainer.remove()
      }

      // Update reset all button visibility (mobile)
      const mobileFilterSection = document.querySelector('[data-mobile-filter-toggle]').parentElement
      const newMobileResetContainer = doc
        .querySelector('[data-mobile-filter-toggle]')
        .parentElement.querySelector('[data-reset-all-container]')
      const currentMobileResetContainer = mobileFilterSection.querySelector('[data-reset-all-container]')

      if (newMobileResetContainer && !currentMobileResetContainer) {
        // Need to add reset button
        mobileFilterSection.insertAdjacentHTML('beforeend', newMobileResetContainer.outerHTML)
      } else if (!newMobileResetContainer && currentMobileResetContainer) {
        // Need to remove reset button
        currentMobileResetContainer.remove()
      }

      // Update mobile product count in modal button
      const newMobileModalCount = doc.querySelector('[data-mobile-product-count]')
      const currentMobileModalCount = document.querySelector('[data-mobile-product-count]')
      if (newMobileModalCount && currentMobileModalCount) {
        currentMobileModalCount.textContent = newMobileModalCount.textContent
      }

      // Update ALL filter dropdowns completely (buttons + panels)
      const filterBar = document.querySelector('[data-filter-bar]')
      const newFilterBar = doc.querySelector('[data-filter-bar]')

      if (filterBar && newFilterBar) {
        const currentDropdowns = filterBar.querySelectorAll('[data-dropdown]')
        const newDropdowns = newFilterBar.querySelectorAll('[data-dropdown]')

        currentDropdowns.forEach(function (currentDropdown, index) {
          if (newDropdowns[index]) {
            const newDropdown = newDropdowns[index]

            // Update trigger button (with badge count and border state)
            const currentTrigger = currentDropdown.querySelector('[data-dropdown-trigger]')
            const newTrigger = newDropdown.querySelector('[data-dropdown-trigger]')

            if (currentTrigger && newTrigger) {
              // Keep the dropdown open state
              const isOpen = !currentDropdown.querySelector('[data-dropdown-panel]').classList.contains('opacity-0')

              // Replace trigger content (includes badge)
              currentTrigger.innerHTML = newTrigger.innerHTML

              // Update trigger classes (border state)
              currentTrigger.className = newTrigger.className

              // Re-apply open state if it was open
              if (isOpen) {
                const panel = currentDropdown.querySelector('[data-dropdown-panel]')
                const arrow = currentDropdown.querySelector('[data-dropdown-arrow]')
                if (panel && arrow) {
                  currentTrigger.classList.add('bg-secondary')
                  currentTrigger.classList.remove('bg-white')
                  arrow.style.transform = 'rotate(180deg)'
                }
              }
            }

            // Update dropdown panel content and classes (border state)
            const currentPanel = currentDropdown.querySelector('[data-dropdown-panel]')
            const newPanel = newDropdown.querySelector('[data-dropdown-panel]')

            if (currentPanel && newPanel) {
              // Keep the dropdown open state for opacity
              const wasOpen = !currentPanel.classList.contains('opacity-0')

              currentPanel.innerHTML = newPanel.innerHTML
              currentPanel.className = newPanel.className

              // Restore open state if it was open
              if (wasOpen) {
                currentPanel.classList.remove('opacity-0', 'pointer-events-none')
              }
            }
          }
        })
      }

      // Remove loading state
      productsGrid.style.minHeight = ''

      // Re-init price inputs after filter AJAX reload
      initPriceInputs()

      // Update URL without page reload
      history.pushState({}, '', url)
    })
    .catch(function (error) {
      console.error('Filter error:', error)
      // Fallback to page reload on error
      window.location.href = url
    })
}

// Price input auto-sizing — keeps EUR suffix right next to the value
window.resizePriceInput = function (input) {
  var text = input.value || input.placeholder || '0'
  var canvas = resizePriceInput._canvas || (resizePriceInput._canvas = document.createElement('canvas'))
  var ctx = canvas.getContext('2d')
  ctx.font = getComputedStyle(input).font
  input.style.width = Math.ceil(ctx.measureText(text).width) + 2 + 'px'
}

// Strip any non-digit characters from text price input
window.filterPriceInput = function (input) {
  input.value = input.value.replace(/[^0-9]/g, '')
}

// Block non-numeric keys in price inputs
window.blockNonNumericKeys = function (e) {
  // Allow control keys: backspace, delete, tab, arrows, home, end
  if (['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(e.key) !== -1) {
    return true
  }
  // Allow Ctrl/Cmd + A/C/V/X
  if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].indexOf(e.key) !== -1) {
    return true
  }
  // Block anything that's not a digit
  if (e.key.length === 1 && !/[0-9]/.test(e.key)) {
    e.preventDefault()
    return false
  }
  return true
}

window.initPriceInputs = function () {
  document.querySelectorAll('[data-price-input]').forEach(function (input) {
    resizePriceInput(input)
  })
}

// Global filter functions (must be available before DOMContentLoaded for inline handlers)
window.applySortRadio = function (input) {
  const value = input.value
  const url = new URL(window.location)
  url.searchParams.set('sort_by', value)
  loadFilteredProducts(url.toString())
}

var mobilePriceDebounceTimer = null

window.applyPriceFilter = function (button) {
  const dd = button.closest('[data-dropdown]')
  if (!dd) return
  const inputs = dd.querySelectorAll('input[data-price-input]')
  const url = new URL(window.location)
  inputs.forEach(function (i) {
    if (i.value && i.name) url.searchParams.set(i.name, i.value)
    else if (i.name) url.searchParams.delete(i.name)
  })
  loadFilteredProducts(url.toString())
}

// Auto-apply mobile price filter with debounce
window.autoApplyMobilePriceFilter = function (input) {
  clearTimeout(mobilePriceDebounceTimer)
  mobilePriceDebounceTimer = setTimeout(function () {
    const modal = input.closest('[data-mobile-filter-modal]')
    if (!modal) return
    const inputs = modal.querySelectorAll('input[data-price-input]')
    const url = new URL(window.location)
    inputs.forEach(function (i) {
      if (i.value && i.name) url.searchParams.set(i.name, i.value)
      else if (i.name) url.searchParams.delete(i.name)
    })
    loadFilteredProducts(url.toString())
  }, 800)
}

window.toggleBooleanFilter = function (checkbox) {
  const name = checkbox.name
  const value = checkbox.value
  const url = new URL(window.location)
  if (checkbox.checked) {
    url.searchParams.set(name, value)
  } else {
    url.searchParams.delete(name)
  }
  loadFilteredProducts(url.toString())
}

window.toggleListFilter = function (el) {
  const name = el.getAttribute('data-param')
  const value = el.getAttribute('data-value')
  const url = new URL(window.location)

  // Get all current values for this filter
  const currentValues = url.searchParams.getAll(name)

  // Remove all values for this parameter first
  url.searchParams.delete(name)

  if (el.checked) {
    // Add back existing values
    currentValues.forEach(function (v) {
      if (v !== value) {
        url.searchParams.append(name, v)
      }
    })
    // Add the new checked value
    url.searchParams.append(name, value)
  } else {
    // Add back only the values that are still checked (excluding the one we just unchecked)
    currentValues.forEach(function (v) {
      if (v !== value) {
        url.searchParams.append(name, v)
      }
    })
  }

  loadFilteredProducts(url.toString())
}

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function () {
  // Init price inputs (auto-size so EUR sits next to value)
  initPriceInputs()

  // Desktop filter dropdowns controller
  ;(function () {
    const bar = document.querySelector('[data-filter-bar]')
    if (!bar) return

    function closeAll(except) {
      bar.querySelectorAll('[data-dropdown]').forEach(function (dd) {
        if (dd === except) return
        const panel = dd.querySelector('[data-dropdown-panel]')
        const arrow = dd.querySelector('[data-dropdown-arrow]')
        const trigger = dd.querySelector('[data-dropdown-trigger]')
        if (panel) {
          panel.classList.add('opacity-0', 'pointer-events-none')
        }
        if (trigger) {
          trigger.classList.remove('bg-secondary')
          trigger.classList.add('bg-white')
        }
        if (arrow) arrow.style.transform = ''
      })
    }

    bar.querySelectorAll('[data-dropdown-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation()
        const dd = trigger.closest('[data-dropdown]')
        const panel = dd.querySelector('[data-dropdown-panel]')
        const arrow = dd.querySelector('[data-dropdown-arrow]')
        const isOpen = !panel.classList.contains('opacity-0')

        closeAll(isOpen ? null : dd)

        if (isOpen) {
          panel.classList.add('opacity-0', 'pointer-events-none')
          trigger.classList.remove('bg-secondary')
          trigger.classList.add('bg-white')
          if (arrow) arrow.style.transform = ''
        } else {
          panel.classList.remove('opacity-0', 'pointer-events-none')
          trigger.classList.add('bg-secondary')
          trigger.classList.remove('bg-white')
          if (arrow) arrow.style.transform = 'rotate(180deg)'
        }
      })
    })

    // Prevent clicks inside panels from closing them
    bar.querySelectorAll('[data-dropdown-panel]').forEach(function (panel) {
      panel.addEventListener('click', function (e) {
        e.stopPropagation()
      })
    })

    // Close all dropdowns when clicking outside
    document.addEventListener('click', function () {
      closeAll(null)
    })
  })()

  // Mobile filter modal
  ;(function () {
    const mobileToggle = document.querySelector('[data-mobile-filter-toggle]')
    const mobileModal = document.querySelector('[data-mobile-filter-modal]')
    const mobileClose = document.querySelectorAll('[data-mobile-filter-close]')
    const mobileApply = document.querySelector('[data-mobile-filter-apply]')
    const mobileRemoveAll = document.querySelector('[data-mobile-filter-remove-all]')
    const productCountEl = document.querySelector('[data-mobile-product-count]')

    let debounceTimer = null

    // Function to build filter URL
    function buildFilterUrl() {
      const url = new URL(window.location)

      // Clear existing filter params
      const keysToDelete = []
      url.searchParams.forEach((value, key) => {
        if (key !== 'page') {
          keysToDelete.push(key)
        }
      })
      keysToDelete.forEach((key) => url.searchParams.delete(key))

      // Add sort
      const sortRadio = mobileModal.querySelector('input[name="sort_by_mobile"]:checked')
      if (sortRadio && sortRadio.value) {
        url.searchParams.set('sort_by', sortRadio.value)
      }

      // Add list filters (checkboxes)
      const listFilters = mobileModal.querySelectorAll('input[data-mobile-filter="list"]:checked')
      listFilters.forEach(function (checkbox) {
        const param = checkbox.getAttribute('data-param')
        const value = checkbox.getAttribute('data-value')
        if (param && value) {
          url.searchParams.append(param, value)
        }
      })

      // Add price range filters
      const priceInputs = mobileModal.querySelectorAll('input[data-mobile-filter="price"][name]')
      priceInputs.forEach(function (input) {
        if (input.value && input.name) {
          url.searchParams.set(input.name, input.value)
        }
      })

      // Add boolean filters
      const booleanFilters = mobileModal.querySelectorAll('input[data-mobile-filter="boolean"]:checked')
      booleanFilters.forEach(function (checkbox) {
        if (checkbox.name && checkbox.value) {
          url.searchParams.set(checkbox.name, checkbox.value)
        }
      })

      return url
    }

    // Function to update product count via AJAX
    function updateProductCount(immediate) {
      if (!productCountEl) return

      // Clear existing timer
      if (debounceTimer) {
        clearTimeout(debounceTimer)
      }

      // For immediate updates (checkboxes, radios), no debounce
      // For text inputs (price), debounce by 500ms
      const delay = immediate ? 0 : 500

      debounceTimer = setTimeout(function () {
        const url = buildFilterUrl()

        fetch(url.toString())
          .then(function (response) {
            return response.text()
          })
          .then(function (html) {
            const parser = new DOMParser()
            const doc = parser.parseFromString(html, 'text/html')
            const countText = doc.querySelector('[data-mobile-product-count]')

            if (countText) {
              productCountEl.textContent = countText.textContent
            }
          })
          .catch(function (error) {
            console.error('Error updating product count:', error)
          })
      }, delay)
    }

    if (mobileToggle && mobileModal) {
      mobileToggle.addEventListener('click', function () {
        mobileModal.classList.remove('hidden')
        // Trigger reflow to enable CSS transition
        mobileModal.offsetHeight
        requestAnimationFrame(function () {
          mobileModal.classList.remove('translate-x-full')
        })
        document.body.style.overflow = 'hidden'
      })

      mobileClose.forEach(function (btn) {
        btn.addEventListener('click', function () {
          mobileModal.classList.add('translate-x-full')
          setTimeout(function () {
            mobileModal.classList.add('hidden')
          }, 300) // Match transition duration
          document.body.style.overflow = ''
        })
      })

      // Apply filters button - closes modal (filters are already applied instantly)
      if (mobileApply) {
        mobileApply.addEventListener('click', function () {
          mobileModal.classList.add('translate-x-full')
          setTimeout(function () {
            mobileModal.classList.add('hidden')
          }, 300) // Match transition duration
          document.body.style.overflow = ''
        })
      }

      // Remove all filters button
      if (mobileRemoveAll) {
        mobileRemoveAll.addEventListener('click', function () {
          // Load filtered products via AJAX instead of page reload
          const url = new URL(window.location)
          const keysToDelete = []
          url.searchParams.forEach(function (value, key) {
            if (key !== 'page') {
              keysToDelete.push(key)
            }
          })
          keysToDelete.forEach(function (key) {
            url.searchParams.delete(key)
          })
          loadFilteredProducts(url.toString())
          // Close modal
          mobileModal.classList.add('hidden')
          document.body.style.overflow = ''
        })
      }

      // Add change listeners to all filter inputs
      mobileModal.querySelectorAll('[data-mobile-filter]').forEach(function (input) {
        const isTextInput = input.type === 'number' || input.type === 'text'

        if (isTextInput) {
          // Debounce for text inputs
          input.addEventListener('input', function () {
            updateProductCount(false)
          })
        } else {
          // Immediate for checkboxes and radios
          input.addEventListener('change', function () {
            updateProductCount(true)
          })
        }
      })

      // Mobile accordion
      document.querySelectorAll('[data-mobile-accordion-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          const content = trigger.nextElementSibling
          const arrow = trigger.querySelector('[data-mobile-accordion-arrow]')
          const isOpen = content.style.gridTemplateRows === '1fr'

          if (isOpen) {
            content.style.gridTemplateRows = '0fr'
            arrow.style.transform = ''
          } else {
            content.style.gridTemplateRows = '1fr'
            arrow.style.transform = 'rotate(180deg)'
          }
        })
      })
    }
  })()
  ;(function () {
    const grid = document.querySelector('[data-products-grid]')
    const trigger = document.querySelector('[data-infinite-scroll-trigger]')

    if (!grid || !trigger) return

    let currentPage = parseInt(grid.getAttribute('data-current-page'))
    const totalPages = parseInt(grid.getAttribute('data-total-pages'))
    const collectionUrl = grid.getAttribute('data-collection-url')
    let isLoading = false

    if (currentPage >= totalPages) {
      trigger.style.display = 'none'
      return
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !isLoading && currentPage < totalPages) {
            loadNextPage()
          }
        })
      },
      {
        rootMargin: '200px', // Start loading 200px before trigger is visible
      }
    )

    observer.observe(trigger)

    function loadNextPage() {
      if (isLoading || currentPage >= totalPages) return

      isLoading = true
      const nextPage = currentPage + 1

      // Build URL for next page - use relative URL to avoid CORS
      const params = new URLSearchParams(window.location.search)
      params.set('page', nextPage)
      const url = window.location.pathname + '?' + params.toString()

      fetch(url)
        .then(function (response) {
          return response.text()
        })
        .then(function (html) {
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          const newProducts = doc.querySelectorAll('[data-products-grid] > div')

          if (newProducts.length > 0) {
            // Append new products to grid
            newProducts.forEach(function (product) {
              grid.appendChild(product)
            })

            currentPage = nextPage
            grid.setAttribute('data-current-page', currentPage)

            // Hide trigger if we've reached the last page
            if (currentPage >= totalPages) {
              trigger.style.display = 'none'
              observer.disconnect()
            }
          }

          isLoading = false
        })
        .catch(function (error) {
          console.error('Error loading more products:', error)
          isLoading = false
        })
    }
  })()
})
